import styled from "../Themes";

export const Container = styled<any>(`div`)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
